export default {
	primary: '#f44336',
  secondary: '#e91e63',
  success: '#ffcdd2',
  warning: '#b71c1c',
  info: '#ec407a',
  error: '#880e4f',
  track: '#d50000'
};